import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CommonService } from 'src/app/core/services/common.service';
import { LoginService } from 'src/app/core/services/login.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-cases',
  templateUrl: './cases.component.html',
  styleUrls: ['./cases.component.css']
})
export class CasesComponent implements OnInit {
  isArabic: any;
  userDetails: any;
  cases: any;
  assessmentDetails: any;

  constructor(private storageService: StorageService, private assessmentService: AssessmentService,
    private commonService: CommonService, private route: Router, private loginService: LoginService) { }

  ngOnInit(): void {
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.userDetails = this.storageService.getSessionStorageData('userDetails');
    //console.log(this.userDetails);

    const rqstBody = { contactguid: this.userDetails?.contactguid, assessmentunitguid: this.userDetails?.assessmentUnitValue };
    this.assessmentService.fetchAllCases(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      //console.log('get all casess: ', decryptedData);
      let casesList = JSON.parse(JSON.stringify(decryptedData));
      //console.log('casesList: ', casesList);
      this.cases = casesList.cases;
    });
  }

  reopenTheCase(eachCase: any, idx: any) {
    const reopenCaseData = {
      contactId: this.userDetails.contactguid,
      assessmentUnit: this.userDetails?.assessmentUnitValue,
      incidentId: eachCase.incidentId
    }
    //console.log(reopenCaseData);
    this.loginService.reopenCase(reopenCaseData).subscribe((data: any) => {
      //console.log('reopen case data: ', data);
      let decryptedData = this.commonService.decryptUsingAES256(data?.data);
      if (decryptedData?.isCaseReopened === true) {
        this.cases[idx].status = 'Reopened';
      }
    });
  }

  openCase(item: any) {
    //console.log(item);
    if (item?.incidentId) {
      const encryptedId = this.commonService.encryptUsingAES256(item?.incidentId)
      if (item && item.caseType == 'General Issues') {
        this.route.navigate(['/report-issue', { details: encryptedId }]);
      }
      else if (item.caseType == 'User Access Request') {
        this.route.navigate(['/request-user-access', { details: encryptedId }]);
      }
    }
  }
}
